import secondaryButton from '../../secondary-button/branded-solid/background/default';

const dark = (params) => secondaryButton.dark(params);

export default dark;
